/**
 * Where "home" is for a diner.
 *
 * It is `/dashboard` and not `/`, and that is temporary. The apex root is
 * currently `root to: redirect("/about", status: 302)` in `config/routes.rb` —
 * a deliberate, documented measure to hide an empty directory in production
 * while no restaurant has launched. `dashboards#show` still serves the same
 * screen at `/dashboard`, so the screen did not move; only its address did.
 *
 * WHY A CONSTANT RATHER THAN FOUR LITERALS. Four places send a diner home: the
 * tab bar's house icon, the brand mark in the desktop nav, the brand mark in
 * the mobile header, and the farewell screen's way out. All four pointed at `/`
 * and all four landed on the marketing page. They have to flip back together
 * when the redirect is reverted, and four literals in three files is how three
 * of them get flipped and the fourth does not.
 *
 * TO REVERT: restore `root to: "dashboards#show"` in `config/routes.rb`, then
 * change this one value to `"/"`. The revert note in that file points here.
 */
export const DINER_HOME_PATH = "/dashboard"
